import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-correction-issue-material-modal',
  templateUrl: './correction-issue-material-modal.component.html',
  styleUrls: ['../modal.component.scss']
})

export class CorrectionIssueMaterialModal implements OnInit {
  @Input() selectedMaterial: any;
  form: FormGroup;
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
    
    this.form.patchValue(this.selectedMaterial);
  }

  initForm(): void {
    this.form = this.fb.group({
      quantityIssued: 0,
      quantityReturned: 0
    });
  }

  emitTrue(): void {
    this.responseChanged.emit(this.form);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}